import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./ReportGenerator.scss";
import {
  MotifIcon,
  MotifButton,
  MotifAccordion,
  MotifAccordionTrigger,
  MotifAccordionContent,
  MotifProgressLoader,
  MotifFormField,
  MotifLabel,
  MotifSelect,
  MotifOption,
  MotifAccordionGroup,
} from "@ey-xd/motif-react";
import {
  contentIcSave24px,
  fileIcFileDownload24px,
  actionIcDelete24px,
  actionIcDone24px,
  imageIcEdit24px,
  contentIcAdd24px,
  hardwareIcKeyboardArrowDown24px,
  hardwareIcKeyboardArrowUp24px,
} from "@ey-xd/motif-react/assets/icons";

import ReportSection from "./ReportSection/ReportSection";
import ReportDetails from "./ReportDetails/ReportDetails";
import ReportType from "./ReportType/ReportType";
import SaveReportModal from "./SaveReportModal/SaveReportModal";

import {
  getReportGenerator,
  addReportGenerator,
  addParsedItem,
  deleteReportGenerator,
  udpateReportGenerator,
  setDomainName,
  setDocumentSet,
  setSelectedReportType,
  setSelectedClientName,
  setSelectedReportName,
  setReportInformation,
} from "../../redux/actions/ReportGenerator/reportGenerator";
import { saveReport } from "../../redux/actions/ReportLibrary/reportLibrary";
import { setReportDetails } from "../../redux/actions/ReportDetails/reportDetails";
import { generateReport } from "../../redux/actions/Report/report";
import {
  getReportSections,
  generateReportSections,
} from "../../redux/actions/ReportSections/reportSections";
import {
  generateRiskScoreGenAI,
  calculateRiskScore,
} from "../../redux/actions/RiskScore/riskScore";
import Input from "../../common/components/Input/Input";
import TextArea from "../../common/components/TextArea/TextArea";
import FileUpload from "../../common/components/FileUpload/FileUpload";
import Modal from "../../common/components/Modal/Modal";
import Toast from "../../common/components/Toast/Toast";
import MultiPageAdd from "../../assets/media/images/multiple-pages-add.png";
import AddFinding from "./AddFinding/AddFinding";
import FindingForm from "./FindingForm/FindingForm";
import { MotifTable } from "@ey-xd/motif-react";
import {
  createFinding,
  deleteFinding,
  saveReportWithFinding,
  generateFinding,
  generateReportWithFinding,
  generateReportWithFindingExcel,
  resetReportInfo,
  backAction,
  setIsVulNameCategoryChanged,
  getReportByID,
} from "../../redux/actions/SideBar/sideBar";
import DeleteModal from "../../components/ReportLibrary/DeleteModal/DeleteModal";

type reportType = "SUMMARY";

const ReportGenerator = () => {
  const advisoryReportSections = [
    {
      id: 1,
      title: "Section 1 - Background",
      prompt:
        "As a cyber threat intelligence analyst, your task is to generate a in-depth and detailed flash report or documentation on the  background and history. These reports should also include in-depth information about relevant attacks, including their nature, origin, potential impact and additional topics that relevant. This report or documentation should also encompass relevant attacks and provide links to additional information that can be found on external websites. The content of this report or documentation will be shared with external clients, so it is crucial that the information is accurate and comprehensive. Don't include any headers but provide very detailed version with all possible content.",
      temperature: 0.2,
    },
    {
      id: 2,
      title: "Section 2 - Technical Details",
      prompt:
        "As a Cyber Threat Intelligence Analyst, you are tasked with generating a comprehensive report on various technical details. Your report should include a thorough analysis of potential indicators of compromise and any other relevant content that could contribute to the understanding of the threat landscape. Consider various forms of cyber threats and their potential impact on different systems or networks. Your report should be detailed, clear, and should provide actionable recommendations for mitigating potential threats. Be sure to include any patterns or trends you observe, and provide your professional insight on potential future threats. Remember, your goal is to provide a resource that can guide decision-making to ensure the protection and integrity of cyber infrastructure. Your creativity and originality in presenting this complex information are highly encouraged.If no information found in the given context, return an empty string.",
      temperature: 0.2,
    },
    {
      id: 3,
      title: "Section 3 - Execution Flow",
      prompt:
        "As a Cyber Threat Intelligence Analyst, you are tasked with generating a execution flow stages for given cyber-attack based on the article given in context.",
      temperature: 0.2,
    },
    {
      id: 4,
      title: "Section 4 - Tactics, Techniques, and Procedures",
      prompt:
        "Create Tactics vs Techniques mapping according to MITRE framework for given attack based on given context.  Give technique IDs and names for below tactics: 1 Intial access, 2 Execution, 3 Persistence, 4 Defense Evasion, 6 Discovery, 7 Lateral movement, 8 Exfiltration 9 Command and Control",
      temperature: 0.2,
    },
    {
      id: 5,
      title: "Section 5 - Recommendations",
      prompt:
        "Imagine you are a cyber threat intelligence analyst who has been asked to provide comprehensive recommendations to a multinational corporation. They want to improve their cybersecurity measures and need expert advice. Your recommendations should cover a wide range of threats, from phishing and malware attacks to data breaches and insider threats. Please provide a detailed analysis of each potential threat, along with your expert recommendations on how to prevent, detect, and respond to each one. Your suggestions should be practical, actionable, and tailored to a large corporation with diverse operations. Remember, your goal is to help the company improve its overall cybersecurity posture and resilience against potential cyber attacks.Dont include any other content apart from recommendations",
      temperature: 0.2,
    },
    {
      id: 6,
      title: "Section 6 - Conclusion",
      prompt:
        "Imagine you are a cyber threat intelligence analyst who has been asked to provide detailed conclusion based on given context",
      temperature: 0.2,
    },
  ];

  const summarySections = [
    {
      id: 1,
      title: "Background",
      prompt:
        "As a cyber threat intelligence analyst, your task is to generate summary on the  background based on given context.The summary should also include information about relevant attacks, including their nature, origin, potential impact and additional topics that relevant. The content of this report or documentation will be shared with external clients, so it is crucial that the information is accurate and comprehensive.Dont include any headers but summarize with all possible content in not more than 100 words.",
      temperature: 0.2,
    },
    {
      id: 2,
      title: "MitreMapping",
      prompt:
        "Title: Identify Tactics vs Techniques. As a cybersecurity analyst, your task is to carefully analyze the given context and list all Tactics vs Techniques. Your audience is the business sector, specifically those involved in cybersecurity. Your tone should be accurate and situational, reflecting the seriousness and precision required in the cybersecurity field. Your output should return information on tactics vs technique mapping as per the given context. Format the output as 'Technique ID: Technique Name' for each tactic according to the MITRE ATT&CK framework. Identify and list all technique IDs and names mentioned in the provided context for each tactic. Strictly follow the information provided in the context; do not apply additional knowledge. If no MITRE mapping information is available for a tactic in the given context, strictly ensure to return empty string if no context provided in the document.",
      temperature: 0.2,
    },
    {
      id: 3,
      title: "Relevance",
      prompt:
        "Generate only two important such keywords which are not more than two words that can be used to identify this threat - it could be a threat actor, a technology they are exploitting, anything particular to this malware based on the given context.Do not generate more than 2 keywords.Do not generate any paragraphs.If not mentioned, strictly ensure to return empty string.",
      temperature: 0.2,
    },
    {
      id: 4,
      title: "InitialAccess",
      prompt:
        "Generate a summary in maximum fifteen words describing how the given cyber attack typically gains initial access to systems or networks based on the article given in context.Do not generate any paragraphs and do not exceed fifteen words.If not mentioned, strictly ensure to return empty string.",
      temperature: 0.2,
    },
    {
      id: 5,
      title: "Exploitation",
      prompt:
        "Describe the given cyber attack in detail, covering these steps:\nInitial compromise (e.g., phishing email, compromised website).\nData collection and reconnaissance.\nDelivery and execution of the payload.\nAnti-detection techniques.\nPersistence mechanisms.\nCommunication with Command and Control (C2) server, based on the article given context in 150 to 160 words.Create only one paragraph.If steps not mentioned in the context,do not generate any answers instead strictly ensure to return empty string.",
      temperature: 0.2,
    },

    {
      id: 6,
      title: "Recommendations",
      prompt:
        "Generate top four recommendations for mitigating the given cyber attack. Include strategies to identify and block adversary activities based on the given context.Do not generate more than four recommendations.If any strategies not mentioned in the given content do not generate any answers, strictly ensure to return empty string.",
      temperature: 0.2,
    },
    {
      id: 7,
      title: "Impacted Industries",
      prompt:
        "Generate a list of top three industries commonly impacted by this cyber attacks based on the given context.Do not generate any paragraphs.If not mentioned do not answer anything, strictly ensure to return empty string.",
      temperature: 0.2,
    },
    {
      id: 8,
      title: "Region",
      prompt:
        "Generate a list of top three regions commonly impacted by this cyber attacks based on the given context.Do not generate any paragraphs.If not mentioned do not answer anything, strictly ensure to return empty string.",
      temperature: 0.2,
    },
    {
      id: 9,
      title: "Activity Group",
      prompt:
        "Identify the top three threat actor groups associated with this malware based on the given context for the given cyber attack. Only mention the group name if available. Do not make up any answers and do not generate any paragraphs.Strictly ensure to return empty string if not found in context.",
      temperature: 0.2,
    },
    {
      id: 10,
      title: "Motive",
      prompt:
        "Generate information about the given cyber attack motives based on the given context in two to three words.Do not generate paragraphs.If not mentioned in the context strictly ensure to return empty string.",
      temperature: 0.2,
    },
  ];

  const dispatch = useDispatch();
  const location = useLocation();
  const [open, setOpen] = useState<boolean>(false);
  const [openDownloadMenu, setOpenDownloadMenu] = useState<boolean>(false);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [toastVisible, setToastVisible] = useState<boolean>(false);
  const [toastData, setToastData] = useState<any>({});
  const [showSpinner, setShowSpinner] = useState<boolean>(false);
  const [showAddFinding, setShowAddFinding] = useState<boolean>(false);
  const [showFindingForm, setShowFindingForm] = useState<boolean>(false);

  const [urls, setUrls] = useState<any>("");
  const [text, setText] = useState<any>("");
  const [files, setFiles] = useState<any>([]);
  const [isReportGeneratedState, setIsReportGeneratedState] =
    useState<boolean>(false);
  const [intelSourceReliability, setIntelSourceReliability] = useState("Yes");
  const [intelSourceAccuracy, setIntelSourceAccuracy] = useState("Yes");
  const [pptContent, setPptContent] = useState<any>();
  const [parsedId, setParsedId] = useState<any>(0);
  const domainName =
    useSelector((state: any) => state?.reportGenerator?.domainName) || "";
  const documentSet =
    useSelector((state: any) => state?.reportGenerator?.documentSet) || "";

  const selectedReportType =
    useSelector((state: any) => state?.reportGenerator?.selectedReportType) ||
    "";
  const selectedClientName =
    useSelector((state: any) => state?.reportGenerator?.selectedClientName) ||
    "";
  const selectedReportName =
    useSelector((state: any) => state?.reportGenerator?.selectedReportName) ||
    "";
  const reportInformation =
    useSelector((state: any) => state?.reportGenerator?.reportInformation) ||
    {};
  const reportInfoFromLibrary =
    useSelector((state: any) => state?.sideBar?.reportInfo) || {};
  const reportGenerator =
    useSelector((state: any) => state?.reportGenerator?.data) || [];
  const reportSections =
    useSelector((state: any) => state?.reportSections?.data) || [];
  const reportDetails =
    useSelector((state: any) => state?.reportDetails?.data) || {};
  const isVulCategoryNameChanged =
    useSelector((state: any) => state?.sideBar?.isVulCategoryNameChanged) ||
    false;
  const currentTenant = useSelector(
    (state: any) => state?.user?.currentTenant
  );
  const isAiaTenant =
    (currentTenant?.TenantName || "").toLowerCase() === "aia";
  const isAllianceTenant =
     (currentTenant?.TenantName || "").toLowerCase() === "allianz";
  const generateRiskScore =
    useSelector((state: any) => state?.riskScore?.generateRiskScore) || {};
  const riskScoreData =
    useSelector((state: any) => state?.riskScore?.riskScoreData) || {};

  const shouldShowReportSections = !!reportSections?.find(
    (i: any) => i?.content
  );
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
  const reportInfo = useSelector((state: any) => state.sideBar.reportInfo);
  const routeMode = (location?.state as any)?.mode;
  const reportMode = reportInfo?.reportMode || routeMode || "edit";
  const isViewMode = reportMode === "view";
  const findingsFromStore = useSelector((state: any) => state.sideBar.findings);
  const [findings, setFindings] = useState(findingsFromStore);
  const [openAccordionIndex, setOpenAccordionIndex] = useState<number>(-1);
  const isFindingCreated = useSelector(
    (state: any) => state.sideBar.isFindingCreated
  );
  const [reportFileName, setReportFileName] = useState<string>("");
  const [reportVersionId, setReportVersionId] = useState<string>(
    isAiaTenant ? location.state?.versionId || reportInfo?.versionId || "" : ""
  );
  const loading = useSelector((state: any) => state.sideBar.loading);
  const errorGenerateReport = useSelector(
    (state: any) => state.sideBar.errorGenerateReport
  );
  const isReportGenerated = useSelector(
    (state: any) => state.sideBar.isReportGenerated
  );
  const isReportLoaded = useSelector(
    (state: any) => state.sideBar.isReportLoaded
  );
  const [deleteFindingId, setDeleteFindingId] = useState<any>(null);
  // Screen visibilities
  const [backEvent, setBackEvent] = useState(false);

  useEffect(() => {
    const defaultReportSections =
      selectedReportType === "SUMMARY"
        ? summarySections
        : advisoryReportSections;
    if (!!selectedReportType) {
      !reportGenerator?.length && dispatch(getReportGenerator([]));
      !reportSections?.length &&
        dispatch(getReportSections(defaultReportSections));
    }
  }, [selectedReportType]);

  useEffect(() => {
    setFindings(findingsFromStore);
  }, [findingsFromStore]);

  useEffect(() => {
    if (isAiaTenant) {
      const vid = reportInfo?.versionId || location.state?.versionId;
      if (vid) setReportVersionId(vid);
    }
  }, [reportInfo?.versionId, isAiaTenant]);

  const resetBuilder = () => {
    dispatch(setDomainName(""));
    setParsedId(0);
    setUrls("");
    setText("");
    setFiles([]);
    dispatch(setDocumentSet(""));
    dispatch(getReportGenerator([]));
    dispatch(setReportDetails({}));
    dispatch(
      getReportSections(
        selectedReportType === "SUMMARY"
          ? summarySections
          : advisoryReportSections
      )
    );
  };

  useEffect(() => {
    if (!isReportLoaded) {
      setShowAddFinding(false);
      setShowFindingForm(false);
      dispatch(resetReportInfo());
    } else {
      setShowFindingForm(true);
      setShowAddFinding(false);
    }
  }, []);

  // Handle tenant change - reset the form and navigate back to ReportType
  useEffect(() => {
    if (currentTenant) {
      const storedTenantId = sessionStorage.getItem("currentTenantId");
      const currentTenantId = currentTenant?.TenantId || "";

      if (storedTenantId && storedTenantId !== currentTenantId) {
        setShowAddFinding(false);
        setShowFindingForm(false);
        dispatch(resetReportInfo());
        dispatch(setSelectedClientName(""));
        dispatch(setSelectedReportName(""));
        dispatch(setReportInformation({}));
        dispatch(setDomainName(""));
        dispatch(setDocumentSet(""));
      }

      sessionStorage.setItem("currentTenantId", currentTenantId);
    }
  }, [currentTenant, dispatch]);

  // Close download menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      const downloadMenu = document.querySelector(".downloadReportButtonGroup");
      if (downloadMenu && !downloadMenu.contains(event.target)) {
        setOpenDownloadMenu(false);
      }
    };

   document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleBackAction = () => {
    setShowAddFinding(false);
    setShowFindingForm(false);
    setBackEvent(true);
    dispatch(backAction());
  };

  const toggleOpen = () => {
    setOpen(!open);
  };

  const toggleDownloadMenu = () => {
    setOpenDownloadMenu(!openDownloadMenu);
  };

  const closeDownloadMenu = () => {
    setOpenDownloadMenu(false);
  };

  const addDatasourceInput = (type: string) => {
    let item;
    const id = reportGenerator.length;
    switch (type) {
      case "Link":
        item = {
          id,
          type: "Link",
        };
        break;
      case "File":
        item = {
          id,
          type: "File",
        };
        break;
      case "Text":
        item = {
          id,
          type: "Text",
        };
        break;
    }
    dispatch(addReportGenerator(item));
    closeDropdown();
  };

  const deleteDatasourceInput = (id: number) => {
    dispatch(deleteReportGenerator(id));
  };

  const closeDropdown = () => {
    setOpen(false);
  };

  const getInfoText = (type: string) => {
    switch (type) {
      case "Link":
        return "You can add multiple links by separating them with comma";
      case "File":
        return "You can add multiple files by dragging and dropping";
      case "Text":
        return "Please type or paste the text here";
    }
  };

  const getDisabledUpload = (type: string) => {
    if (!domainName) {
      return true;
    }
    switch (type) {
      case "Link":
        return !urls;
      case "File":
        return !files;
      case "Text":
        return !text;
    }
  };
  const handleDrop = (event: any, index: any) => {
    const updatedItem = reportGenerator.find((i: any) => i.id === index);
    setFiles(event);
    const fileDetails = event.map((file: any) => ({
      name: file.name,
      size: file.size,
    }));
    dispatch(udpateReportGenerator({ ...updatedItem, fileDetails }));
  };
  const flexCenter = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const parseData = (type: any, itemId: any) => {
    let newParsedId = parsedId + 1;
    setParsedId(newParsedId);
    let updatedDocumentSet: any = documentSet;
    if (!updatedDocumentSet) {
      const uniqueId = uuidv4();
      updatedDocumentSet = `${domainName}_${uniqueId}`;
      dispatch(setDocumentSet(updatedDocumentSet));
    }
    switch (type) {
      case "Link":
        const formDataLink = new FormData();
        formDataLink.append("document_id", `${newParsedId}`);
        formDataLink.append("document_set", updatedDocumentSet);
        formDataLink.append("urls", urls);
        dispatch(addParsedItem(formDataLink, itemId));
        break;
      case "File":
        let newParsedIdForFile = parsedId;
        files?.forEach((file: any, index: any) => {
          newParsedIdForFile = parsedId + index + 1;
          const formData = new FormData();
          formData.append("document_id", `${newParsedIdForFile}`);
          formData.append("document_set", updatedDocumentSet);
          formData.append("document_name", file.name);
          formData.append("file", file);
          dispatch(addParsedItem(formData, itemId));
        });
        setParsedId(newParsedIdForFile);
        break;
      case "Text":
        const formDataText = new FormData();
        formDataText.append("document_id", `${newParsedId}`);
        formDataText.append("document_set", updatedDocumentSet);
        formDataText.append("text", text);
        dispatch(addParsedItem(formDataText, itemId));
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const sectionLoading = reportSections?.reduce(
      (acc: any, curr: any) => curr?.loading || acc,
      false
    );
    setShowSpinner(sectionLoading);
  }, [reportSections]);

  useEffect(() => {
    if (!!generateRiskScore.data) {
      dispatch(calculateRiskScore(generateRiskScore.data));
      setShowSpinner(false);
    }
  }, [generateRiskScore]);

  const handleGenerateRiskScore = () => {
    const defaultRiskScoreProfile = {
      "Client Profile": selectedClientName,
      "Risk Score Profile": "default",
      "Reliable Source": intelSourceReliability,
      "Intel accuracy": intelSourceAccuracy,
      "Multiple Intels": "Yes",
      domain: domainName,
      document_set_id: documentSet,
    };
    setShowSpinner(true);
    dispatch(generateRiskScoreGenAI(defaultRiskScoreProfile));
  };

  const handlePostResponse = (
    header: string,
    message: string,
    variant: string
  ) => {
    setShowSpinner(false);
    setToastData({ header, message, variant });
    setToastVisible(true);
    variant !== "error" &&
      setTimeout(() => {
        setToastVisible(false);
      }, 5000);
  };

  const handleGenerateReport = async () => {
    const payload = {
      report_id: reportInfo.reportId,
    };
    try {
      if (isAllianceTenant) {
        await dispatch(generateReportWithFindingExcel(payload));
      }
      const res: any = await dispatch(generateReportWithFinding(payload));
      if (isAiaTenant) {
        setReportFileName(res?.value?.data?.report_file_name || "");
        setReportVersionId(res?.value?.data?.version_id || res?.value?.version_id || "");
      }
      if (errorGenerateReport) {
        handlePostResponse("Error", "Failed to generate the report", "error");
        setIsReportGeneratedState(false);
        return;
      }
      setIsReportGeneratedState(true);
      handlePostResponse(
        "Success",
        "Successfully generated the report",
        "success"
      );
      if (isAiaTenant) {
        dispatch(getReportByID({ report_id: reportInfo.reportId, isAiaTenant: true }));
      }
      } catch (error) {
      handlePostResponse("Error", "Failed to generate the report", "error");
      setIsReportGeneratedState(false);
    }
  };

  const handleSaveandGenerateReport = async () => {
    const findingsReportToSave = findings.filter(
      (item: any) => !item.isSavedInReport && item?.status === "Completed"
    );
    setShowSpinner(true);
    try {
      await dispatch(
        saveReportWithFinding({
          report_id: reportInfo.reportId,
          FindingsList: formatFindingsList(findingsReportToSave),
        })
      );
      await handleGenerateReport();
    } catch (error) {
      handlePostResponse(
        "Error",
        "Failed to save and generate the report",
        "error"
      );
    } finally {
      setShowSpinner(false);
    }
  };
  const droppedFileDetails = (files: any) =>
    files
      .map(
        (file: any, index: number) =>
          `${index + 1}. Name: ${file.name}\n Size: ${file.size}kb`
      )
      .join("\n");

  const generateSection = (id: number, prompt: string, randomness: number) => {
    const isSummary = selectedReportType === "SUMMARY";
    const requestParams = {
      Prompt: prompt,
      domain: domainName,
      document_set_id: documentSet,
      temperature: randomness / 100,
      section_id: id,
    };
    dispatch(generateReportSections(requestParams, id, isSummary));
  };

  const appendComments = (content: any) => {
    const dataToParse = content?.domains && content?.domains[0]?.subDomains;
    if (!dataToParse) {
      return "";
    }
    let comments = "";
    dataToParse.forEach((d: any) => {
      d.questions &&
        d.questions.forEach((q: any) => {
          comments += q.question ? q.question + "\n" : "";
          comments += q.comments ? q.comments?.join("\n") + "\n" : "";
          comments += q.references
            ? "References:\n" + q.references?.join("\n") + "\n"
            : "";
        });
    });
    return comments;
  };

  const downloadReport = async (format: string = "DOCX") => {
    setShowSpinner(true);
    closeDownloadMenu();
    const endpoint= format === "EXCEL" ? "/report/download-excel" : "/report/download";
    // X-User-Email removed: identity is derived from the JWT server-side.
    fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("idToken")}`,
        "X-Tenant-ID": sessionStorage.getItem("tenant") ? JSON.parse(sessionStorage.getItem("tenant") || '{}').TenantId : '',
      },
      method: "POST",
      body: JSON.stringify({
        report_id: reportInfo.reportId,
        ...(isAiaTenant && reportVersionId ? { version_id: reportVersionId } : {}),
      }),
    })
      .then((resp) => {
        if (resp.ok) {
          const disposition = resp.headers.get('content-disposition');
          const filenameMatch = disposition?.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          const apiFilename = filenameMatch ? filenameMatch[1].replace(/['"]/g, '').trim() : null;
          return resp.arrayBuffer().then((buffer) => ({ buffer, apiFilename }));
        } else {
          handlePostResponse(
            "Failed",
            "Unable to download Report. Please try again.",
            "error"
          );
          throw new Error("Something went wrong");
        }
      })
      .then(({ buffer, apiFilename }: { buffer: ArrayBuffer; apiFilename: string | null }) => {
        let mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        let fileExtension = ".docx";
        
        if (format === "EXCEL") {
         mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
         fileExtension = ".xlsx";
        }
        
        const file = new Blob([buffer], {
          type: mimeType,
        });
        const reportName = reportInfo.reportName;
        const fileName = apiFilename
          || (format === "DOCX" && !isAllianceTenant && reportInfo.ReportFileName ? reportInfo.ReportFileName.split('/').pop() || reportInfo.ReportFileName : undefined);
        // process to auto download it
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = isAllianceTenant
          ? (reportName || "report") + fileExtension
          : reportFileName.length > 0 ? reportFileName + fileExtension : fileName ? fileName : reportName + fileExtension;
        link.click();
        link.remove();
      })
      .catch((e: any) => console.error(e))
      .finally(() => {
        setShowSpinner(false);
      });
  };
  const formatFindingsList = (findings: any) => {
    return findings.map((item: any) => {
      return {
        finding_id: item.finding_id || item.id,
        CVSSVectorString: item.aiGeneratedContent.cvss_vector,
        // BaseLineCVSSVectorString: item.aiGeneratedContent.baseline_cvss_vector,
        CVSSScore: item.aiGeneratedContent.cvss_score,
        Complexity: item.aiGeneratedContent.complexity,
        Priority: item.aiGeneratedContent.priority,
        Recommendation: item.aiGeneratedContent.recommendation,
        Likelyhood: item.aiGeneratedContent.likelihood,
        ReferenceURLs: item.aiGeneratedContent.references,
        Severity: item.aiGeneratedContent.cvss_severity,
        //---------------------------------------------
        Category: item.vul_category || item.vulnerabilityCategory,
        FindingName: item.vul_name || item.vulnerabilityName,
        Description: item.vul_desc || item.vulnerabilityDescription,
        ImpactedAssets: item.vul_assets_impacted || item.affectedAssets,
        Impact: item.vul_impact || item.impact,
        LikelyhoodDescription: item.vul_likelyhood_desc || item.likelihoodType,
        port: item.port || "",
        cwe: item.cwe || "",
        StepsFollowedList: isAiaTenant
          ? (item.aiaUseCases
              ? formatAiaStepsFollowedList(item.aiaUseCases, item.finding_id || item.id)
              : formatAiaUseCasesFromStore(item.useCases || [], item.finding_id || item.id))
          : formatStep(item.steps || item.stepsToReproduce),
      };
    });
  };
  const formatStep = (step: any) => {
    return step.map((item: any, index: any) => {
      return {
        StepNumber: index + 1,
        StepDescription: item.step_description,
        Id: item.step_id,
        ImageCaption: item.image_caption,
        EncodedImage: item.encoded_image,
        ImageLabel: item.image_label,
        FindingId: item.finding_id,
      };
    });
  };

  const formatAiaStepsFollowedList = (aiaUseCases: any[], findingId: any) => {
    return aiaUseCases.map((uc: any) => ({
      UseCaseId: uc.useCaseApiId || uc.id,
      UseCaseName: uc.title,
      steps: (uc.steps || []).map((step: any, stepIdx: number) => ({
        Id: step.stepApiId || undefined,
        StepDescription: step.description || "",
        StepNumber: stepIdx + 1,
        FindingId: findingId,
        UseCaseId: uc.useCaseApiId || uc.id,
        EncodedImage: "",
        ImageCaption: "",
        ImageLabel: "",
        ImageLink: "",
        Images: (step.uploadedImages || []).map((img: any) => ({
          Id: img.id,
          Caption: img.caption || "",
          ImageLabel: img.imageLabel || "",
          ImageLink: img.imageLink || "",
        })),
      })),
    }));
  };

  // Formats use cases that come from the Redux store (finding.useCases built by groupStepsIntoUseCases)
  const formatAiaUseCasesFromStore = (useCases: any[], findingId: any) => {
    return useCases.map((uc: any) => ({
      UseCaseId: uc.use_case_id,
      UseCaseName: uc.use_case_name,
      steps: (uc.steps || []).map((step: any, stepIdx: number) => ({
        Id: step.step_id || undefined,
        StepDescription: step.step_description || "",
        StepNumber: stepIdx + 1,
        FindingId: findingId,
        UseCaseId: uc.use_case_id,
        EncodedImage: "",
        ImageCaption: "",
        ImageLabel: "",
        ImageLink: "",
        Images: (step.images || []).map((img: any) => ({
          Id: img.Id || img.id,
          Caption: img.Caption || img.caption || "",
          ImageLabel: img.ImageLabel || img.image_label || "",
          ImageLink: img.ImageLink || img.image_link || "",
        })),
      })),
    }));
  };
  const handleSaveReport = () => {
    if (isViewMode) {
      handlePostResponse(
        "Info",
        "This report version is read-only. Open the latest version to edit.",
        "info"
      );
      return;
    }
    const findingsReportToSave = findings.filter(
      (item: any) =>
        (!item.isSavedInReport && item.status === "Completed") ||
        (item.isLoaded && item.status === "Editing")
    );
    setShowSpinner(true);
    const findingsPayload = formatFindingsList(findingsReportToSave).map(
      ({ BaseLineCVSSVectorString, ...rest }: any) => rest
    );
    dispatch(
      saveReportWithFinding({
        report_id: reportInfo.reportId,
        FindingsList: findingsPayload,
      })
    ).then(() => {
      handlePostResponse("Success", "Successfully saved the report", "success");
      dispatch(getReportByID({ report_id: reportInfo.reportId, isAiaTenant }));
    });
  };

  const handleAddFinding = () => {
    if (isViewMode) {
      handlePostResponse(
        "Info",
        "This report version is read-only. Open the latest version to edit.",
        "info"
      );
      return;
    }
    setShowSpinner(true);
    dispatch(
      createFinding({
        report_id: reportInfo?.reportId,
        report_state: "draft",
      })
    )
      .then(() => {
        setShowSpinner(false);
      })
      .finally(() => {
        setOpenAccordionIndex(findings.length);
      });
  };

  const saveFinding = (findingData: any) => {
    setShowSpinner(true);
    const findingsPayload = formatFindingsList([findingData]).map(
      ({ BaseLineCVSSVectorString, ...rest }: any) => rest
    );
    dispatch(
      saveReportWithFinding({
        report_id: reportInfo.reportId,
        FindingsList: findingsPayload,
      })
    )
      .then(() => {
        handlePostResponse(
          "Success",
          "Successfully updated the finding",
          "success"
        );
        setIsReportGeneratedState(false);
        setOpenAccordionIndex(-1);
      })
      .catch((error: any) => {
        handlePostResponse(
          "Error",
          "Error while updating the finding",
          "error"
        );
        setIsReportGeneratedState(true);
      })
      .finally(() => {
        dispatch(setIsVulNameCategoryChanged(false));
        setOpenAccordionIndex(-1); // Close accordion after API completed
        setShowSpinner(false);
        dispatch(getReportByID({ report_id: reportInfo.reportId, isAiaTenant }));
      });
  };
  const handleGenerateFinding = (findingData: any) => {
    if (isViewMode) {
      handlePostResponse(
        "Info",
        "This report version is read-only. Open the latest version to edit.",
        "info"
      );
      return;
    }
    const payload = isAiaTenant
      ? {
          application_name: reportInfo.applicationName || "",
          client_name: reportInfo.clientName || "",
          cwe: findingData.cwe || "",
          finding_id: findingData.id,
          port: findingData.port || "",
          report_id: reportInfo.reportId,
          steps: findingData.aiaSteps || [],
          vul_assets_impacted: findingData.affectedAssets,
          vul_category: findingData.vulnerabilityCategory,
          vul_desc: findingData.vulnerabilityDescription,
          vul_impact: findingData.impact,
          vul_likelyhood_desc: findingData.likelihoodType,
          vul_name: findingData.vulnerabilityName,
        }
      : {
          client_name: reportInfo.clientName,
          application_name: reportInfo.applicationName,
          report_id: reportInfo.reportId,
          vul_name: findingData.vulnerabilityName,
          vul_category: findingData.vulnerabilityCategory,
          vul_desc: findingData.vulnerabilityDescription,
          vul_assets_impacted: findingData.affectedAssets,
          vul_impact: findingData.impact,
          vul_likelyhood_desc: findingData.likelihoodType,
          finding_id: findingData.id,
        };
    
    setShowSpinner(true);
    dispatch(generateFinding(payload))
      .then(() => {
        setFindings((prevFindings: any) => {
          const updatedFindings = prevFindings.map((finding: any) =>
            finding.finding_id === findingData.id
              ? { ...finding, vul_name: findingData?.vulnerabilityName }
              : finding
          );
          if (
            !updatedFindings.some((f: any) => f.finding_id === findingData.id)
          ) {
            updatedFindings.push({
              ...findingData,
              vul_name: findingData.vulnerabilityName,
            });
          }
          return updatedFindings;
        });
        handlePostResponse(
          "Success",
          "Successfully generated the finding",
          "success"
        );
        setIsReportGeneratedState(false);
        setOpenAccordionIndex(-1);
        if (isAiaTenant) {
          dispatch(getReportByID({ report_id: reportInfo.reportId, isAiaTenant: true }));
        }
      })
      .catch((error: any) => {
        alert("Invalid input data for Generate Findings");
        setShowSpinner(false);
        setIsReportGeneratedState(true);
      })
      .finally(() => {
        isVulCategoryNameChanged && saveFinding(findingData);
        setOpenAccordionIndex(-1); // Close accordion after API completed
      });
  };
  const handleUpdateFinding = (findingData: any, index: any) => {
    if (isViewMode) {
      handlePostResponse(
        "Info",
        "This report version is read-only. Open the latest version to edit.",
        "info"
      );
      return;
    }
    if (isVulCategoryNameChanged) {
      handleGenerateFinding(findingData);
      return;
    }
    saveFinding(findingData);
  };

  const handleDelete = (finding_id: any) => {
    if (isViewMode) {
      handlePostResponse(
        "Info",
        "This report version is read-only. Open the latest version to edit.",
        "info"
      );
      return;
    }
    setShowSpinner(true);
    dispatch(
      deleteFinding({
        finding_id,
      })
    )
      .then(() => {
        handlePostResponse(
          "Success",
          "Finding deleted successfully",
          "success"
        );
        setIsReportGeneratedState(false);
      })
      .catch((error: any) => {
        handlePostResponse("Error", "Error while delete the finding", "error");
        setIsReportGeneratedState(true);
      })
      .finally(() => {
        setOpenAccordionIndex(-1); // Close accordion after API completed
        setShowSpinner(false);
      });
  };

  const isSaveReportDisabled = () => {
    return isReportGeneratedState
      ? true
      : findings?.length === 0 ||
          findings.filter(
            (item: any) => item?.status === "Completed" || item.isLoaded
          ).length === 0;
  };
  const isValidFindings =
    findings?.length > 0 && findings?.every((item: any) => item.isLoaded);

  return (
    <div className="reportGeneratorWrapper">
      <MotifProgressLoader show={showSpinner || loading} />
      <div className="breadCrumbs">Reports</div>
      <div className="heading">
        <div className="title">Report Generator</div>
        <div className="description">
          Welcome to the ASC Cloud - AuPen AI. This
          user-friendly tool takes your security findings and turns them into a
          clear, standard report. Just enter the details of your findings, and
          our GenAI system will do the rest. It calculates risk scores, gives
          advice, and puts it all into a Word document that's ready for you to
          check and share with your clients. Get your reports done quickly and
          easily.
        </div>
      </div>
      <div className="report__generator__content">
        <div className="inputWrapper">
          <div className="inputWrapper__heading">
            <div className="inputWrapper__heading__title">
              {reportInfo?.reportName} {reportInfo?.clientName}{" "}
            </div>
            {isViewMode && (
              <div style={{ color: "#595959", fontSize: "14px", marginTop: "4px" }}>
                View mode: older version (read-only)
              </div>
            )}
            <div className="inputWrapper__heading__description">
              <div>
                Input all the details from your testing into the tool. After
                you've added all your findings, simply click on "Generate
                Report" to create the Word document. This process is quick and
                straightforward, ensuring you get your report ready with ease.
              </div>
            </div>
            <div className="actions">
              <MotifButton
                size="medium"
                variant="text"
                type="button"
                className="saveReport"
                disabled={
                  isViewMode ||
                  isSaveReportDisabled() ||
                  !isValidFindings ||
                  openAccordionIndex !== -1
                }
                onClick={handleSaveReport}
              >
                <MotifIcon src={contentIcSave24px} />
                <span className="buttonText">Save Report</span>
              </MotifButton>
              {!isAiaTenant ? (
                <div className="downloadReportButtonGroup">
                  <MotifButton
                    size="medium"
                    variant="secondary"
                    type="button"
                    className="downloadReport"
                    disabled={!isReportGenerated || (isViewMode && findings.length === 0)}
                    onClick={toggleDownloadMenu}
                  >
                    <div className="downloadButtonContent">
                      <MotifIcon src={fileIcFileDownload24px} className="downloadIcon" />
                      <span className="buttonText">Download Report</span>
                      <MotifIcon 
                        src={openDownloadMenu ? hardwareIcKeyboardArrowUp24px : hardwareIcKeyboardArrowDown24px} 
                        className="chevronIcon" 
                      />
                    </div>
                  </MotifButton>
                  {openDownloadMenu && (
                    <div className="downloadMenu">
                      <MotifButton
                        size="medium"
                        variant="text"
                        type="button"
                        className="downloadOption"
                        onClick={() => downloadReport("DOCX")}
                      >
                        <span>Download as DOCX</span>
                      </MotifButton>
                      <MotifButton
                        size="medium"
                        variant="text"
                        type="button"
                        className="downloadOption"
                        onClick={() => downloadReport("EXCEL")}
                      >
                        <span>Download as Excel</span>
                      </MotifButton>
                    </div>
                  )}
                </div>
              ) : (
                <MotifButton
                  size="medium"
                  variant="text"
                  type="button"
                  className="downloadReport"
                  disabled={!isReportGenerated || (isViewMode && findings.length === 0)}
                  onClick={() => downloadReport("DOCX")}
                >
                  <MotifIcon src={fileIcFileDownload24px} />
                  <span className="buttonText">Download Report</span>
                </MotifButton>
              )}
            </div>
          </div>
        </div>
        <div style={!reportGenerator.length ? flexCenter : {}}>
          {!showAddFinding && !showFindingForm && (
            <ReportType
              reportID={reportInfo.reportId}
              reportType={selectedReportType}
              setReportType={(reportType: any) =>
                dispatch(setSelectedReportType(reportType))
              }
              clientName={selectedClientName}
              setClientName={(clientName: string) =>
                dispatch(setSelectedClientName(clientName))
              }
              reportName={selectedReportName}
              setReportName={(reportName: any) =>
                dispatch(setSelectedReportName(reportName))
              }
              setShowAddFinding={setShowAddFinding}
              setShowFindingForm={setShowFindingForm}
              findings={findingsFromStore}
              setFormData={(formData: any) =>
                dispatch(setReportInformation(formData))
              }
              reportInformation={
                backEvent && !isReportLoaded
                  ? reportInformation
                  : backEvent && isReportLoaded
                  ? reportInfoFromLibrary
                  : {}
              }
              handlePostResponse={handlePostResponse}
            />
          )}
        </div>
        {showAddFinding && (
          <AddFinding
            setShowFindingForm={setShowFindingForm}
            setShowAddFinding={setShowAddFinding}
          />
        )}
        {showFindingForm && (
          <>
            <div
              className="report-generator-header"
              style={{ background: "#FAFAFC" }}
            >
              <div>Finding</div>
              <div>Severity</div>
              <div>Status</div>
              <div>Actions</div>
            </div>
            {isViewMode && findings.length === 0 && (
              <div style={{
                padding: "32px 16px",
                textAlign: "center",
                color: "#595959",
                fontSize: "14px",
                border: "1px dashed #d0d0d0",
                borderRadius: "4px",
                margin: "16px 0",
              }}>
                This version has no data and report associated with it.
              </div>
            )}
            {findings.map((row: any, index: number) => {
              const isOpen = openAccordionIndex === index;
              return (
                <div key={index} className="report-generator-wrapper">
                  <div
                    key={index}
                    className="report-generator-row"
                    onClick={() => {
                      setOpenAccordionIndex(isOpen ? -1 : index);
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {isOpen ? (
                        <MotifIcon
                          src={hardwareIcKeyboardArrowUp24px}
                          className="accordian-icon"
                        />
                      ) : (
                        <MotifIcon
                          src={hardwareIcKeyboardArrowDown24px}
                          className="accordian-icon"
                        />
                      )}
                      {Array.isArray(row?.vul_name) && row.vul_name?.length > 0
                        ? row.vul_name?.join("")
                        : typeof row?.vul_name === "string"
                        ? row.vul_name
                        : row.finding}
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {row?.aiGeneratedContent?.cvss_severity
                        ? row?.aiGeneratedContent?.cvss_severity
                        : ""}
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <MotifIcon
                        src={
                          isOpen || row.status === "New"
                            ? imageIcEdit24px
                            : actionIcDone24px
                        }
                        style={{
                          color:
                            isOpen || row.status === "New" ? "orange" : "green",
                          width: "18px",
                          marginRight: "8px",
                        }}
                      />
                      {isOpen ? "Editing" : row.status}
                    </div>
                    <div style={{ display: "flex" }}>
                      {!isViewMode && (
                        <MotifIcon
                          src={actionIcDelete24px}
                          style={{
                            color: "grey",
                            width: "18px",
                            marginRight: "8px",
                          }}
                          onClick={(e: any) => {
                            e.stopPropagation();
                            setDeleteFindingId(row.finding_id);
                          }}
                        />
                      )}
                    </div>
                  </div>
                  {isOpen && (
                    <div
                      className="motif-accordion-content report-generator-content"
                      key={row.finding_id || row.Id}
                    >
                      <FindingForm
                        handleGenerateFinding={handleGenerateFinding}
                        handleUpdateFinding={handleUpdateFinding}
                        index={index}
                        status={row.status}
                        finding={row}
                        isViewMode={isViewMode}
                      />
                    </div>
                  )}
                </div>
              );
            })}
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                marginTop: "20px",
              }}
            >
              <MotifButton
                size="medium"
                variant="secondary"
                onClick={() => {
                  handleAddFinding();
                }}
                disabled={isViewMode}
              >
                <MotifIcon src={contentIcAdd24px} />
                Add Finding
              </MotifButton>
            </div>
          </>
        )}

        {!!reportGenerator.length && selectedReportType === "SUMMARY" && (
          <div className={"interSource"}>
            <MotifFormField style={{ width: "300px" }}>
              <MotifLabel>Intel Source Reliability (required)</MotifLabel>
              <MotifSelect
                onChange={(val: string) => {
                  setIntelSourceReliability(val);
                }}
                value={intelSourceReliability}
                visibleOptions={3}
              >
                <MotifOption value="Yes">Yes</MotifOption>
                <MotifOption value="No">No</MotifOption>
                <MotifOption value="Neutral">Neutral</MotifOption>
              </MotifSelect>
            </MotifFormField>
            <MotifFormField style={{ width: "300px" }}>
              <MotifLabel>Intel Source Accuracy (required)</MotifLabel>
              <MotifSelect
                onChange={(val: string) => {
                  setIntelSourceAccuracy(val);
                }}
                value={intelSourceAccuracy}
                visibleOptions={3}
              >
                <MotifOption value="Yes">Yes</MotifOption>
                <MotifOption value="No">No</MotifOption>
                <MotifOption value="Neutral">Neutral</MotifOption>
              </MotifSelect>
            </MotifFormField>
          </div>
        )}
        {riskScoreData?.data && (
          <>
            <div className="generateReportHeader">Generated Report</div>
            <MotifAccordion
              alignIconRight
              useChevronIcon
              style={{ padding: "16px 16px 0 16px" }}
            >
              <MotifAccordionTrigger>
                Report Settings/ Paramaters
              </MotifAccordionTrigger>
              <MotifAccordionContent>
                <ReportDetails
                  reportDetails={reportDetails}
                  riskScore={riskScoreData?.data}
                  generateRiskScore={generateRiskScore?.data}
                  reportName={selectedReportName}
                  clientName={selectedClientName}
                  setShowSpinner={setShowSpinner}
                ></ReportDetails>
              </MotifAccordionContent>
            </MotifAccordion>
          </>
        )}
        {reportDetails?.reportName && (
          <ReportDetails reportDetails={reportDetails} />
        )}
        {shouldShowReportSections && (
          <div className="reportSectionWrapper">
            <div className="reportSectionHeader">Report Sections</div>
            <div className="reportSections">
              {reportSections?.map((section: any, index: number) => {
                return (
                  <div key={index}>
                    <MotifAccordion alignIconRight useChevronIcon>
                      <MotifAccordionTrigger>
                        {section?.title}
                      </MotifAccordionTrigger>
                      <MotifAccordionContent>
                        <ReportSection
                          id={section?.id}
                          defaultPrompt={section?.prompt}
                          defaultContent={appendComments(section?.content)}
                          defaultRandomness={section?.temperature}
                          loading={section?.loading}
                          generateSection={generateSection}
                        />
                        {section?.error && (
                          <div style={{ color: "red", padding: 8 }}>
                            Generate section failed...!!! Please try to generate
                            this particular section again by clicking on
                            "Generate Section" button.
                          </div>
                        )}
                      </MotifAccordionContent>
                    </MotifAccordion>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      <div className="submitWrapper">
        <MotifButton
          size="medium"
          variant="text"
          type="button"
          // disabled={!reportGenerator.length}
          // onClick={resetBuilder}
          onClick={handleBackAction}
          disabled={!showAddFinding && !showFindingForm}
        >
          <span className="buttonText">Back</span>
        </MotifButton>
        <MotifButton
          size="medium"
          variant="primary"
          type="button"
          // disabled={!documentSet}
          // onClick={handleGenerateReport}
          disabled={isViewMode || isSaveReportDisabled() || !isValidFindings}
          onClick={handleSaveandGenerateReport}
        >
          <MotifIcon src={contentIcSave24px} />
          Generate Report
        </MotifButton>
      </div>
      <SaveReportModal
        visibility={modalVisible}
        setVisibility={setModalVisible}
      />
      <Toast
        visible={toastVisible}
        setVisible={setToastVisible}
        children={
          <div>
            <div className={"toastHeader"}>{toastData?.header}</div>
            <div className={"toastContent"}>{toastData?.message}</div>
          </div>
        }
        variant={toastData?.variant}
      />
      <DeleteModal
        report={findings.find(
          (item: any) => item.finding_id == deleteFindingId
        )}
        isVisible={deleteFindingId}
        setIsVisible={setDeleteFindingId}
        onConfirmClick={() => handleDelete(deleteFindingId)}
        isFinding={true}
      />
    </div>
  );
};

export default ReportGenerator;
